// extracted by mini-css-extract-plugin
module.exports = {"btnContainer":"ProposalModalNavButtons_btnContainer__1felG","propNavigationButtons":"ProposalModalNavButtons_propNavigationButtons__3EbRy"};